/**
 * ArbiHunter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: ROOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { InfluenceResumeChannelDTO } from '../models/InfluenceResumeChannelDTO';
import { InfluenceResumeContactsDTO } from '../models/InfluenceResumeContactsDTO';
import { InfluenceResumeStatisticDTO } from '../models/InfluenceResumeStatisticDTO';
import { HttpFile } from '../http/http';

export class InfluenceResumeDTO {
    /**
    * Unique influence resume id.
    */
    'id': number;
    /**
    * Link to avatar.
    */
    'avatar'?: string;
    /**
    * Profile username.
    */
    'name': string;
    /**
    * Resume description.
    */
    'description': string;
    /**
    * Indicates, if executor add this resume to favourites.
    */
    'isFavourite'?: boolean;
    /**
    * Resume published status.
    */
    'published': boolean;
    /**
    * Amount of completed steps.
    */
    'completedSteps'?: number;
    /**
    * Resume statistic. Available only to resume\'s owner.
    */
    'statistic'?: InfluenceResumeStatisticDTO;
    /**
    * Resume contacts. Available to resume\'s owner and anyone who opened it.
    */
    'contacts'?: InfluenceResumeContactsDTO;
    /**
    * Available channels.
    */
    'channels': Array<InfluenceResumeChannelDTO>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "avatar",
            "baseName": "avatar",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "isFavourite",
            "baseName": "isFavourite",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "published",
            "baseName": "published",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "completedSteps",
            "baseName": "completedSteps",
            "type": "number",
            "format": ""
        },
        {
            "name": "statistic",
            "baseName": "statistic",
            "type": "InfluenceResumeStatisticDTO",
            "format": ""
        },
        {
            "name": "contacts",
            "baseName": "contacts",
            "type": "InfluenceResumeContactsDTO",
            "format": ""
        },
        {
            "name": "channels",
            "baseName": "channels",
            "type": "Array<InfluenceResumeChannelDTO>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return InfluenceResumeDTO.attributeTypeMap;
    }

    public constructor() {
    }
}
